import React from "react";
import { Card, Button } from "react-bootstrap";
import { FiPhone, FiMail, FiMessageSquare } from "react-icons/fi";

export default function TeamMembersCard() {
  const members = [
    {
      name: "Alexander Jermai",
      role: "UI/UX Designer",
      img: "/assets/img/users/user-35-1.jpg",
    },
    {
      name: "Doglas Martini",
      role: "Product Designer",
      img: "/assets/img/users/user-02.jpg",
    },
    {
      name: "Daniel Esbella",
      role: "Project Manager",
      img: "/assets/img/users/user-03.jpg",
    },
    {
      name: "Daniel Esbella",
      role: "Team Lead",
      img: "/assets/img/users/user-04.jpg",
    },
    {
      name: "Stephan Peralt",
      role: "Team Lead",
      img: "/assets/img/users/user-05.jpg",
    },
    {
      name: "Andrew Jermia",
      role: "Project Lead",
      img: "/assets/img/users/user-06.jpg",
    },
  ];

  return (
    <>
      <Card className="h-100" style={styles.card}>
        
        {/* Header */}
        <Card.Header style={styles.header}>
          <h5 style={styles.title}>Team Members</h5>
          <Button style={styles.button}>View All</Button>
        </Card.Header>

        {/* Body */}
        <Card.Body style={{ padding: 0 }}>
          {members.map((m, i) => (
            <div key={i} style={styles.row}>
              
              {/* LEFT */}
              <div style={styles.left}>
                <img src={m.img} alt="" style={styles.avatar} />

                <div>
                  <h6 style={styles.name}>{m.name}</h6>
                  <span style={styles.role}>{m.role}</span>
                </div>
              </div>

              {/* RIGHT ICONS */}
              <div style={styles.right}>
                <div style={styles.iconBox}><FiPhone size={16} /></div>
                <div style={styles.iconBox}><FiMail size={16} /></div>
                <div style={styles.iconBox}><FiMessageSquare size={16} /></div>
              </div>

            </div>
          ))}
        </Card.Body>
      </Card>
    </>
  );
}

/* INTERNAL STYLES */
const styles = {
  card: {
    border: "2px solid #e6e8ec",
    borderRadius: "5px",
    overflow: "hidden",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    background: "#fff",
    borderBottom: "1px solid #eef0f3",
  },

  title: {
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
    color: "#1f2a37",
  },

  button: {
    background: "#f3f4f6",
    border: "none",
    fontSize: "13px",
    padding: "6px 14px",
    borderRadius: "6px",
    color: "#111827",
  },

  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  avatar: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  name: {
    fontSize: "15px",
    fontWeight: "600",
    margin: 0,
    color: "#1f2a37",
  },

  role: {
    fontSize: "13px",
    color: "#6b7280",
  },

  right: {
    display: "flex",
    gap: "10px",
  },

  iconBox: {
    width: "34px",
    height: "34px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#374151",
    background: "#fff",
    cursor: "pointer",
  },
};